import React, { ReactElement } from 'react';
interface BadgeProps {
  text: string;
};
const Badge = ({ text }: BadgeProps): ReactElement => {
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
      {text}
    </span>
  )
};

export default Badge;
